import Raven from 'raven-js';
import _ from 'lodash';

import config from '../config';
import InAppStore from '../stores/InAppStore';
import UserStore from '../stores/UserStore';
import OrderStore from '../stores/OrderStore';
import CurrentTripStore from '../stores/CurrentTripStore';

const userFields = config.get('environment') === 'prod' ? ['id'] : ['id', 'fullName', 'email'];

const excludeErrors = [
    /TypeError: .*(null.*_currentElement|_currentElement.*null)/,
    /Error: Minified exception occurred/,
    /TypeError: Network request failed/,
    /TypeError: Failed to fetch/,
    /TypeError: this\.get\(\.\.\.\)\.querySelectorAll is not a function/,
    /TypeError: plugin\.setSuspendState is not a function/,
    /SyntaxError: Unexpected token </,
    /TypeError: Failed to execute 'removeChild' on 'Node': parameter 1 is not of type 'Node'/,
    /undefined: \[object Event\]/,
    /Error: Out of memory/,
    /undefined: RangeError: Maximum call stack size exceeded/
];

function addErrorContext (data = {}) {
    const currentUser = UserStore.getCurrent();
    if (currentUser.isLoggedIn()) {
        data.user = _.pick(currentUser, userFields);
    }
    data.tags = Object.assign({}, data.tags, {
        'app': config.get('name'),
        'in-app': !!InAppStore.isInApp()
    });

    const order = OrderStore.getCurrent();
    const trip = CurrentTripStore.get();
    const lastException = Raven.lastException() || new Error();
    data.extra = Object.assign({}, data.extra, lastException.extra, {
        'order.id': order.id,
        'order.state': order.state,
        'order.products': JSON.stringify(order.getProducts()),
        'order.totalPrice': order.getTotalPrice(),
        'order.expiry': order.expiry && order.expiry.format(),
        'order.fulfilment': order.getDeliveryMethodName(),
        'trip.type': trip.getType(),
        'trip.isValid': trip.isValid(),
        'trip': JSON.stringify(trip)
    });

    return data;
}

function shouldSendError (data) {
    const exception = data.exception && data.exception.values[0];
    const message = exception
        ? (exception.type ? exception.type + ': ' : '') + exception.value
        : data.message;
    if (!message || excludeErrors.some((pattern) => message.match(pattern))) {
        return false;
    }
    return true;
}

export function init (version) {
    const dsn = InAppStore.isInApp() ? config.get('ravenDSNTAB') : config.get('ravenDSN');
    if (dsn) {
        Raven.config(dsn, { release: version })
            .setTagsContext({
                brand: config.get('brand'),
                environment: config.get('environment')
            })
            .setDataCallback(addErrorContext)
            .setShouldSendCallback(shouldSendError)
            .install();
    }
}

export default function reportError (error) {
    Raven.captureException(error, { extra: error.extra });
}



// WEBPACK FOOTER //
// ./src/helpers/ErrorReporter.js